import { t } from 'i18next';
import { AbstractBlock } from '../blockly/AbstractBlock';
import { blocklyStore } from './blocklyStore';

export default class ToolBoxContainer {
  categorys = [];

  static autoHideSizeLimit = 768;

  addCategory(category) {
    this.categorys.push(category);
    return this;
  }

  toXmlDom() {
    AbstractBlock.initUseLibrary();
    const toolbox = document.createElement('xml');
    this.categorys.forEach((cat) => {
      const categoryDom = cat.toXml();
      if (categoryDom) {
        toolbox.appendChild(categoryDom);
      }
    });

    // DOMをそのまま返せば、小文字変換問題は発生しない
    return toolbox;
  }

  notify() {
    this.categorys.forEach((category) => category.notify());
  }

  getAllCategoryAllBlocks() {
    let all = [];
    this.categorys.forEach((category) => {
      all = all.concat(category.getAllBlocks());
    });
    return all;
  }

  private _isVisible = true;
  isVisible(): boolean {
    return this._isVisible;
  }

  setVisible(isVisible: boolean) {
    console.log('toolbox', blocklyStore.workspace.getToolbox());
    if (isVisible) {
      // Toolboxを表示する
      (document.querySelector('.blocklyToolboxDiv') as any).style.display = 'block';
      (document.querySelector('.blocklyFlyout') as any).style.display = 'block';
      (document.querySelector('.blocklyScrollbarVertical') as any).style.display = 'block';
      (document.querySelector('.blocklyFlyoutScrollbar') as any).style.display = 'block';
      blocklyStore.workspace.getToolbox().width = 310;
      blocklyStore.workspace.getToolbox().toolboxPosition = 1;
      // blocklyStore.workspace.getToolbox().setVisible(isVisible);
    } else {
      // Toolboxを非表示にする
      (document.querySelector('.blocklyToolboxDiv') as any).style.display = 'none';
      (document.querySelector('.blocklyFlyout') as any).style.display = 'none';
      (document.querySelector('.blocklyScrollbarVertical') as any).style.display = 'none';
      (document.querySelector('.blocklyFlyoutScrollbar') as any).style.display = 'none';
      // (document.querySelector('.blocklyFlyout') as any).style.width = 0;
      // blocklyStore.workspace.getToolbox().setVisible(isVisible);
      blocklyStore.workspace.getToolbox().toolboxPosition = 0;
      // blocklyStore.workspace.getToolbox().width = 1;

      // blocklyScrollbarVertical
      // blocklyMainWorkspaceScrollbar
    }
    this._isVisible = isVisible;
  }

  responsive() {
    if (window.innerWidth < ToolBoxContainer.autoHideSizeLimit) {
      this.setVisible(false);
    } else {
      this.setVisible(true);
    }
  }
}

export class FlatToolBoxContainer extends ToolBoxContainer {
  toXmlDom() {
    AbstractBlock.initUseLibrary();
    const toolbox = document.createElement('xml');
    this.categorys.forEach((cat) => {
      const xmlList = cat.toFlatXml();
      if (xmlList !== null) {
        for (const blockXml of xmlList) {
          toolbox.appendChild(blockXml);
        }
      }
    });
    // DOMをそのまま返せば、小文字変換問題は発生しない
    return toolbox;
  }

  notify() {
    this.categorys.forEach((category) => {
      category.notify();
    });
  }
}
